module.exports = __webpack_public_path__ + "static/media/Rohan Singh.c1a64a07.png";